module.exports = __webpack_public_path__ + "static/img/221014-Police-ba original.3472b144.png";